export const getExtension = (fileSrc: string) =>
  fileSrc?.slice(fileSrc.lastIndexOf('.'));
